import { render, staticRenderFns } from "./orderTitle.vue?vue&type=template&id=2d1bdad3&scoped=true"
import script from "./orderTitle.vue?vue&type=script&lang=js"
export * from "./orderTitle.vue?vue&type=script&lang=js"
import style0 from "./orderTitle.vue?vue&type=style&index=0&id=2d1bdad3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1bdad3",
  null
  
)

export default component.exports